import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { KeyValue } from "../models/common";
import { IContactTypeApi } from "./base/contactTypeApi";
import { ContactTypeDomain } from "../models/request";

const baseRoute: string = "ContactType";

export class ContactTypeApi extends IContactTypeApi {
	getDomain(request?: ContactTypeDomain): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: request });
	}
	getPublicDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain_public`);
	}
}
